<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb(:data="items")
        el-col.pt-5.text-right(:span="15")
          el-button(v-if="true" type="primary" size="mini" :loading="loading" @click="edit") 保存
          el-button(v-if="true" type="primary" size="mini" @click="$router.go(-1)") 返回
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      div 基本信息
      el-form.my-3(:model="form" ref="form" label-width="100px" :rules="rules" v-loading="loading" size="mini")
        el-row(type="flex" justify="center" :gutter="20")
          el-col(:span="12")
            el-form-item(label="公司" prop="id")
              el-select.w-100(v-model="form.id" disabled :filter-method="sourcestockorg" filterable placeholder="需求组织" clearable)
                el-option(v-for="item in stockorg" :key="item.pk_org" :label="item.name" :value="item.pk_org")
            el-form-item(label="收货地址" prop="address")
              el-input.w-100(v-model="form.address" placeholder="收货地址")
            el-form-item(label="收货人" prop="person")
              el-select.w-100(v-model="form.person" :loading="loadingPerson" filterable remote placeholder="收货人" :remote-method="getPersonList" )
                el-option(v-for="item in person" :key="item.pk_psndoc" :label="item.name" :value="item.pk_psndoc")
            el-form-item(label="联系方式")
              el-input.w-100(v-model.number="form.contact" placeholder="联系方式" disabled)
</template>
<script>
import { validatePhone } from "@/utils/validate";
export default {
  data() {
    return {
      items: [
        {
          path: "/purchase/purchase_demand",
          meta: {
            title: "公司管理",
          },
        },
        {
          path: this.$route.path,
          meta: {
            title: "编辑",
          },
        },
      ],
      h: "",
      loading: false,
      form: {
        id: "",
        address: "",
        person: "",
        contact: "",
      },
      rules: {
        id: [{ required: true, message: "请选择公司", trigger: "change" }],
        address: [
          { required: true, message: "请填写收货地址", trigger: "blur" },
        ],
        person: [
          { required: true, message: "请选择收货人", trigger: "change" },
        ],
        contact: [
          { required: true, message: "请填写手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
      },
      loadingPerson: false,
      person: [],
    };
  },
  props: ["id"],
  methods: {
    async getPersonList(query) {
      this.loadingPerson = true;
      let res = await this.$api.global.personList({
        key_name: query,
        pk_org: this.form.id,
        page_size: 2000,
        page_num: 1,
      });
      this.loadingPerson = false;
      if (res) {
        this.person = res.data;
      }
    },
    edit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          delete this.form.modify_date;
          let res = await this.$api.address.edit([this.form]);
          this.loading = false;
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.$router.go(-1);
          }
        }
      });
    },
    async getById() {
      let res = await this.$api.address.getById(this.id);
      if (res) {
        this.form = res.data;
        this.getPersonList();
      }
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    if (this.$store.state.token && this.$store.state.stock_org == false)
      this.getStockOrg();
    this.getById();
  },
};
</script>